// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2FAnO","gfeWrapper":"CalendarEvent_gfeWrapper__20Ub2"};